<template>
  <SpectreText
    size="sm"
    color="light"
  >
    <slot />
  </SpectreText>
</template>

<script lang="ts" setup>
import { SpectreText } from '@agentsoftware/spectre-ui';
</script>
